import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailDomainValidator(): ValidatorFn
{
    return (control: AbstractControl): ValidationErrors | null =>
    {
        const email: string = control.value || '';
        const domainPart = email.substring(email.lastIndexOf('@') + 1);
        return domainPart.includes('.') ? null : { domainInvalid: true };
    };
}